import React from 'react';
import {Navigate, RouterProvider, createBrowserRouter} from 'react-router-dom';

import {screens} from '../screens';
import {TabNavigator} from './TabNavigator';
import {Home} from '../screens/tabs/Home';
import {Categories} from '../screens/tabs/Categories';
import {Profile} from '../screens/tabs/Profile';
import {Wishlist} from '../screens/tabs/Wishlist';
import {Order} from '../screens/tabs/Order';
import {Notifications} from '../screens/Notification';
const stack = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to='/Home' />, // Redirect to Home
  },
  {
    path: '/SignIn',
    element: <screens.SignIn />,
  },
  {
    path: '/Home',
    element: <Home />,
  },
  {
    path: '/Categories',
    element: <Categories />,
  },
  {
    path: '/Order',
    element: <Order />,
  },
  {
    path: '/notifications',
    element: <Notifications />,
  },
  {
    path: '/Wishlist',
    element: <Wishlist />,
  },
  {
    path: '/Wishlist',
    element: <Wishlist />,
  },
  {
    path: '/Profile',
    element: <Profile />,
  },
  {
    path: '/EditProfile',
    element: <screens.EditProfile />,
  },
  {
    path: '/Product',
    element: <screens.Product />,
  },
  {
    path: '/Shop',
    element: <screens.Shop />,
  },
  {
    path: '/ShopHome',
    element: <screens.ShopHome />,
  },
  {
    path: '/Reviews',
    element: <screens.Reviews />,
  },
  {
    path: '/Description',
    element: <screens.Description />,
  },
  {
    path: '/OrderHistory',
    element: <screens.OrderHistory />,
  },
  {
    path: '/Checkout',
    element: <screens.Checkout />,
  },
  {
    path: '/OrderSuccessful',
    element: <screens.OrderSuccessful />,
  },
  {
    path: '/OrderFailed',
    element: <screens.OrderFailed />,
  },
  {
    path: '/MyPromocodes',
    element: <screens.MyPromocodes />,
  },
  {
    path: '/SignOut',
    element: <screens.SignOut />,
  },
  {
    path: '/SendPhoneOtp',
    element: <screens.SendPhoneOtp />,
  },
  {
    path: '/Verification',
    element: <screens.Verification />,
  },
  {
    path: '/SendEmailOtp',
    element: <screens.SendEmailOtp />,
  },
  {
    path: '/OrderHistoryEmpty',
    element: <screens.OrderHistoryEmpty />,
  },
  {
    path: '/EmailVerified',
    element: <screens.EmailVerified />,
  },
  {
    path: '/PhoneVerified',
    element: <screens.PhoneVerified />,
  },
  {
    path: '/SignUp',
    element: <screens.SignUp />,
  },
  {
    path: '/SignUpAccountCreated',
    element: <screens.SignUpAccountCreated />,
  },
  {
    path: '/ForgotPassword',
    element: <screens.ForgotPassword />,
  },
  {
    path: '/NewPassword',
    element: <screens.NewPassword />,
  },
  {
    path: '/ForgotPasswordSentEmail',
    element: <screens.ForgotPasswordSentEmail />,
  },
  {
    path: '/DeleteAccount',
    element: <screens.DeleteAccount />,
  },
  {
    path: '/ShippingAndPaymentInfo',
    element: <screens.ShippingAndPaymentInfo />,
  },
  {
    path: '/InfoSaved',
    element: <screens.InfoSaved />,
  },
  {
    path: '/LeaveAReview',
    element: <screens.LeaveAReview />,
  },
  {
    path: '/MyPromocodesEmpty',
    element: <screens.MyPromocodesEmpty />,
  },
  {
    path: '/Filter',
    element: <screens.Filter />,
  },
]);

export const StackNavigator: React.FC = () => {
  return <RouterProvider router={stack} />;
};
